import React from 'react';
import TierGrid from '../TierGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import { useTiers } from '../../_hocs/withTiers';
import { useCurrentTier } from '../../_hocs/withCurrentTier';
import { MeasuredCookieType } from '../../../Measured';
import TierCardForExplorer from './TierCardForExplorer';
const TierExplorer = ()=>{
    const { tiers, isTierStreamInitialized, isFetchingTiers, hasMoreTiers, fetchMoreTiers } = useTiers();
    const { setCurrentTierId } = useCurrentTier();
    const onTierClick = (tier)=>{
        setCurrentTierId(tier.deviationId);
    };
    const renderTier = ({ index, width })=>{
        const tier = tiers[index];
        return /*#__PURE__*/ React.createElement(TierCardForExplorer, {
            width: width,
            deviation: tier,
            onClick: onTierClick
        });
    };
    const fetchMoreTiersIfNeeded = ()=>{
        if (!hasMoreTiers || isFetchingTiers) {
            return;
        }
        fetchMoreTiers();
    };
    const renderContent = ()=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isTierStreamInitialized && /*#__PURE__*/ React.createElement(TierGrid, {
            cookieType: MeasuredCookieType.GALLECTION_EXPLORER,
            tiers: tiers,
            tierRenderer: renderTier
        }), isFetchingTiers && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !tiers.length
        }));
    };
    return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
        scrollableContent: renderContent(),
        onScrolledToBottom: fetchMoreTiersIfNeeded,
        onNotScrollable: fetchMoreTiersIfNeeded
    });
};
TierExplorer.displayName = 'TierExplorer';
export default TierExplorer;
